import React from "react";
import { Navigate, useLocation } from "react-router-dom";

const AdminGuard = (props) => {
  const token = localStorage.getItem("token");
  const user = JSON.parse(localStorage.getItem("user"));
  let location = useLocation();

  if (!token || !user) {
    if (user?.roleId !== 0) {
      localStorage.removeItem("token");
      localStorage.removeItem("user");
      return <Navigate to="/" state={{ from: location }} replace />;
    } else {
      localStorage.removeItem("token");
      localStorage.removeItem("user");
      return <Navigate to="/" state={{ from: location }} replace />;
    }
  }

  return props.children;
};

export default AdminGuard;
